import axios from "axios";
const wapper = config => {
  return new Promise((resolve, reject) => {
    axios(config).then(res => {
      resolve(res.data);
    }).catch(err => {
      reject(err);
    });
  });
};
export const getInvitesList = data => {
  return wapper({
    url: "/api/inviteLink/page",
    method: "post",
    params: data
  });
};
export const getUnitTree = () => {
  return wapper({
    url: "/api/user/unitsTree",
    method: "get"
  });
};
// 全部重置
export const resetInviteLink = data => {
  return wapper({
    url: "/api/inviteLink/allReset",
    method: "get",
    data
  });
};
export const createInviteLink = data => {
  return wapper({
    url: "/api/inviteLink/buildInviteLink",
    method: "post",
    data
  });
};
// 获取单位组织架构数
export const getOrganizationTreeTree = () => {
  return wapper({
    url: "/api/organization/user/tree",
    method: "get"
  });
};
// 删除邀请链接
export const deleteInviteLink = params => {
  return wapper({
    url: "/api/inviteLink/deleteInviteLink",
    method: "get",
    params
  });
};
// 邀请申请列表
export const inviteUserList = params => {
  return wapper({
    url: "/api/inviteLink/inviteUserDetail",
    method: "get",
    params
  });
};
// 审批邀请用户详细信息
export const approveInviteUserDetail = params => {
  return wapper({
    url: "/api/inviteLink/approveInviteUserDetail",
    method: "get",
    params
  });
};
// 创建新管理员邀请链接(重新构建管理员邀请链接)
export const buildNewAdminInviteLink = params => {
  return wapper({
    url: "/api/inviteLink/buildNewAdminInviteLink",
    method: "get",
    params
  });
};
export const decryptMask = params => {
  return wapper({
    url: "/api/inviteLink/decrypt",
    method: "get",
    params
  });
};
export const getLatestInviteLink = params => {
  return wapper({
    url: "/api/inviteLink/getLatestInviteLink",
    method: "get",
    params
  });
};
// 获取用户所在部门查询当前登录用户的所属部门id
export const getOrgDept = data => {
  return wapper({
    url: "/api/gig/addressBook/member/departmentIds/current",
    method: "get",
    data
  });
};
export default {
  getInvitesList,
  getUnitTree,
  resetInviteLink,
  createInviteLink,
  getOrganizationTreeTree,
  deleteInviteLink,
  inviteUserList,
  approveInviteUserDetail,
  buildNewAdminInviteLink,
  decryptMask,
  getOrgDept,
  getLatestInviteLink
};